import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import { Separator } from 'apps/auth/components/common/Layout/Separator';
import { Text } from 'apps/auth/components/common/Text/Text';
import { AMOUNT_TO } from 'apps/auth/constants/fieldsName';
import { resolveArguments } from 'apps/auth/helpers/utils';
import { useExtra, usePageMessages } from 'apps/auth/hooks/selectors';

import SelectMethod from './SelectMethod';
import { getSortAndFilterArray } from '../utils/utils';

const PaymentMethodScreenSorted = (props) => {
    const { commission, availablePaymentMethodsList = {}, paymentMethodsOrder = {} } = useExtra();
    const { selectHowToReceive, payRequestPayTitle } = usePageMessages();
    const amountToValue = useSelector(({ form }) => form[props.formName]?.fields[AMOUNT_TO]?.value);

    const paymentMethodsGroups = useMemo(
        () => getSortAndFilterArray(paymentMethodsOrder?.sourceOptionsGroups, availablePaymentMethodsList),
        [availablePaymentMethodsList, paymentMethodsOrder?.sourceOptionsGroups],
    );
    return (
        <>
            <HeaderPanel
                title={resolveArguments(props.isCreate ? selectHowToReceive : payRequestPayTitle, `${amountToValue} ${commission?.restrictionTo?.ccyIso}`)}
            />
            {paymentMethodsGroups.map(({ description, paymentOptionsItems }, index, array) => {
                const paymentOptionsItemsSort = paymentOptionsItems.sort((a, b) => a.order - b.order);
                return (
                    <div key={`${description}-${index}`} data-testid="request-payment-methods-sorted">
                        <Text variant="div" size="subheader" color="secondary" indent="adaptive-16-24">
                            {description}
                        </Text>
                        {paymentOptionsItemsSort.map(({ category, badge, actionBanner }) => {
                            const paymentMethod = availablePaymentMethodsList[category];
                            if (paymentMethod) {
                                return (
                                    <SelectMethod
                                        key={paymentMethod?.method}
                                        method={paymentMethod}
                                        badge={badge}
                                        actionBanner={actionBanner}
                                        sourcesBonus={props.sourcesBonus}
                                        sourcesGA={props.sourcesGA}
                                        sourcesCards={props.sourcesCards}
                                        sourcesAccounts={props.sourcesAccounts}
                                        selectedBonus={props.selectedBonus}
                                        chooseLibre={props.chooseLibre}
                                        selectedCard={props.selectedCard}
                                        selectedGAccount={props.selectedGAccount}
                                        selectedGooglePay={props.selectedGooglePay}
                                        sourceCode={props.sourceCode}
                                        amountValue={props.amountValue}
                                        isCreate={props.isCreate}
                                        setIsNewAccount={props.setIsNewAccount}
                                        addCard={props.addCard}
                                        addAccount={props.addAccount}
                                        formName={props.formName}
                                        popupRef={props.popupRef}
                                    />
                                );
                            }
                            return null;
                        })}
                        {index !== array.length - 1 ? <Separator /> : null}
                    </div>
                );
            })}
        </>
    );
};

export default PaymentMethodScreenSorted;
